import './services/firebaseApp'

import { StyleProvider, ReactQuery, I18NProvider, useEffect } from '@codeleap/common'
import { Settings, variantProvider, React, I18N } from './app'
import { AppStatusOverlay, DebugModal, GlobalStyle, NoReviewQuestionsModal, OrganisationInfo, ReviewOrganisation, ReviewOrgSuccessModal, ShareModal, UnknownOrganisation, CongratulationsStories, variants, AchievementDetail, AchievementModal, PlayerYoutube } from './components'
import { Provider } from 'react-redux'
import { Pulse, store } from './redux'
import { APIClient, analytics } from './services'
import CreateStory from './components/Modals/CreateStory'
import StoryDetails from './components/Modals/StoryDetail'
import { Location } from '@reach/router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useHandleOpen, useUtm } from './utils'
import { globalHistory } from '@reach/router'

export const Overlays = () => (
  // This is needed for useLocation to work inside the modals
  <Location>
    {() => <>
      <DebugModal />
      <OrganisationInfo />
      <ReviewOrganisation />
      <UnknownOrganisation />
      <CreateStory />
      <NoReviewQuestionsModal />
      <ReviewOrgSuccessModal />
      <StoryDetails />
      <ShareModal />
      <CongratulationsStories />
      <AchievementDetail />
      <AchievementModal />
      <PlayerYoutube.Fullscreen />
    </>
    }
  </Location>
)

const App = ({ children }) => {
  const response = APIClient.Session.useSession(true)
  useHandleOpen({
    mapping: {
      openQuestions: undefined,
      questions: undefined,
      'openCreateStory': 'createStory',
    },
    onOpen: () => Pulse.toggleModal('start_page', true),
  })

  //@ts-ignore
  useUtm(response.profile)

  useEffect(() => {
    globalHistory.listen(({ action }) => {
      if (response.isLoggedIn && action === 'PUSH') {
        analytics?.track('logged_in_pageview')
      }
    })
  }, [globalHistory])

  return (
    <>
      <GlobalStyle />
      {children}
      <AppStatusOverlay />
      <Overlays />
    </>
  )
}

export const Root = ({ children }) => {
  return (
    <ReactQuery.QueryClientProvider client={APIClient.queryClient.client}>
      <ReactQueryDevtools initialIsOpen={false} position='right' />
      <Provider store={store}>
        <StyleProvider
          settings={Settings}
          variantProvider={variantProvider}
          variants={variants}
          logger={logger}
        >
          <I18NProvider i18n={I18N}>
            <Location>
              {() => <>
                <App>
                  {children}
                </App>

              </>}
            </Location>
          </I18NProvider>
        </StyleProvider>
      </Provider>
    </ReactQuery.QueryClientProvider>
  )
}
